var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isInteger, hideWhenDisplaying, hideWhenCreating, hideWhenCreatingAndEditing } from 'src/types/columnFlags';
import getRecordById from 'src/utils/entityOperations/getRecordById';
import getFullTable from 'src/utils/entityOperations/getFullTable';
const controlledActions = {
    create: [306],
    fetch: [309],
    update: [307],
    delete: [308],
    downloadList: [-1],
    uploadList: [-1]
};
const columns = () => {
    const getRuleConditionType = (id) => {
        const result = getRecordById('ci.rule_condition_types', id);
        if (!result) {
            throw new Error('Rule condition type ' + id + ' not found');
        }
        else {
            return result;
        }
    };
    const getRuleConditionTypeValueType = (id) => { var _a; return (_a = getRuleConditionType(id)) === null || _a === void 0 ? void 0 : _a.value_type; };
    const cellReferences = (row) => {
        const rc = getRuleConditionType(row.rule_condition_type_id);
        if (!rc)
            return;
        const referenceEntity = rc.reference_entity;
        if (referenceEntity) {
            const list = getFullTable(referenceEntity);
            return list;
        }
        else {
            return undefined;
        }
    };
    const ruleConditionDisplayValueGetter = (row, value) => {
        const rct = getRuleConditionType(row.rule_condition_type_id);
        const referenceEntity = rct === null || rct === void 0 ? void 0 : rct.reference_entity;
        if (referenceEntity) {
            const list = getFullTable(referenceEntity);
            if (!list)
                return '<empty>';
            const refRow = list.find((r) => r.id === value) || {};
            return refRow.name || '<empty>';
        }
        else {
            return String(value) || '<empty>';
        }
    };
    const getAvailablePredicates = (ctx, props) => __awaiter(void 0, void 0, void 0, function* () {
        if (!props)
            return [];
        const rct = getRuleConditionType(props.row.rule_condition_type_id);
        return (rct === null || rct === void 0 ? void 0 : rct.available_predicates) || [];
    });
    const columns = [
        // @ts-ignore
        { name: 'row_menu', type: 'row_menu', style: 'width:25px;', menuItemShortcuts: ['create', 'copy', 'delete'], hideWhenCreating: true },
        { name: 'id', label: 'ID', style: 'width:50px', field: 'id', align: 'left', hideWhenDisplaying, hideWhenCreating, isInteger },
        { name: 'rule_id', label: 'Rule ID', field: 'rule_id', hideWhenDisplaying },
        { name: 'rule_condition_type_id', style: 'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:45%!important;', defaultValueWhenCreating: 1, editable: true, label: 'Where condition', field: 'rule_condition_type_id', align: 'left', required: true, references: 'ci.rule_condition_types' },
        { name: 'rule_condition_value_date', hideWhenDisplaying, hideWhenCreatingAndEditing },
        { name: 'rule_condition_value_integer', hideWhenDisplaying, hideWhenCreatingAndEditing },
        { name: 'rule_condition_value_time', hideWhenDisplaying, hideWhenCreatingAndEditing },
        { name: 'predicate', style: 'width:5%!important;', label: '*', field: 'predicate', defaultValueWhenCreating: '=', editable: true, references: getAvailablePredicates, hideWhenDisplaying, hideWhenCreatingAndEditing },
        {
            name: 'condition_value',
            label: 'Condition value',
            editable: true,
            field: 'condition_value',
            style: 'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:45%!important;',
            required: true,
            sourceField: (props) => 'rule_condition_value_' + getRuleConditionTypeValueType(props.row.rule_condition_type_id),
            cellIsDate: (props) => getRuleConditionTypeValueType(props.row.rule_condition_type_id) === 'date',
            cellIsTime: (props) => getRuleConditionTypeValueType(props.row.rule_condition_type_id) === 'time',
            inlineEdit: (props) => getRuleConditionTypeValueType(props.row.rule_condition_type_id) === 'integer' && !cellReferences(props.row),
            cellReferences(props) { return cellReferences(props.row); },
            valueGetter: (props) => {
                const rct = getRuleConditionTypeValueType(props.row.rule_condition_type_id);
                if (rct === undefined)
                    console.error('Rule condition type is undefined on rule condition ' + props.row.id);
                // @ts-ignore
                const res = props.row['rule_condition_value_' + rct];
                if (res === undefined && rct !== undefined)
                    console.error('Rule condition value is undefined on rule condition ' + props.row.id);
                return res || null;
            },
            displayValueGetter(props) { return ruleConditionDisplayValueGetter(props.row, (this.valueGetter ? this.valueGetter(props) : null)); }
        }
    ];
    return columns;
};
const localEntity = constructLocalEntity({
    // @ts-ignore
    columns,
    remoteEntityName: 'ci.rule_conditions',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Rule conditions'
});
export default localEntity;
